import blogs from './blogs';
import common from './common';
import globalSearch from './global-search';
import home from './home';
import products from './products';
import providers from './providers';
import shoppingCart from './shopping-cart';
import subscriptions from './subscriptions';
import users from './users';
import aboutUs from './about-us';
import faq from './faq';
import membre from './membre';
import discovery from './discovery';
import checkout from './checkout';

export default {
  blogs,
  common,
  globalSearch,
  home,
  products,
  providers,
  shoppingCart,
  subscriptions,
  users,
  aboutUs,
  faq,
  membre,
  discovery,
  checkout
};
